import { Redirect } from 'react-router-dom';
import useDetectTv from '@/hooks/useDetectTv';
import { getLocalItem } from '@/utils/localStorage.util';
import { ROUTES } from './routes';

interface RequireAuthProps {
    children: React.ReactNode;
}

/**
 * Synchronous, render-time auth guard. It is evaluated during render, so an
 * unauthenticated visitor is redirected before the protected page mounts — no
 * flash of protected content and no premature data-fetching (the layout-level
 * guards rely on a post-render useEffect). The redirect target mirrors
 * useLoginRedirect: QR login on a TV, standard login otherwise.
 */
function RequireAuth({ children }: RequireAuthProps) {
    const isTV = useDetectTv();
    const isAuthenticated = !!getLocalItem<string>('accessToken');

    if (!isAuthenticated) {
        return (
            <Redirect
                to={isTV ? ROUTES.AUTH.LOGIN_WITH_QR : ROUTES.AUTH.LOGIN}
            />
        );
    }

    return <>{children}</>;
}

export default RequireAuth;
